import { TextField } from "@mui/material";

interface IProps {
  value: {
    bannerText: { en: string; tr: string };
    buttonText: { en: string; tr: string };
    buttonLink: string;
  };
  onChange: (value: IProps["value"]) => void;
}

export default function EximWebsiteSettings({ value, onChange }: IProps) {
  const handleChange = (key: keyof IProps["value"], update: any) => {
    onChange({ ...(value || {}), [key]: update } as any);
  };

  return (
    <div className="w-full flex flex-col gap-4">
      <TextField
        label="Banner text English"
        value={value?.bannerText?.en || ""}
        onChange={(e) =>
          onChange({
            ...(value || {}),
            bannerText: { en: e.target.value, tr: value?.bannerText?.tr },
          } as any)
        }
      />

      <TextField
        label="Banner text Turkish"
        value={value?.bannerText?.tr || ""}
        onChange={(e) =>
          onChange({
            ...(value || {}),
            bannerText: { tr: e.target.value, en: value?.bannerText?.en },
          } as any)
        }
      />

      <TextField
        label="Banner button English"
        value={value?.buttonText?.en || ""}
        onChange={(e) =>
          onChange({
            ...(value || {}),
            buttonText: { en: e.target.value, tr: value?.buttonText?.tr },
          } as any)
        }
      />

      <TextField
        label="Banner button Turkish"
        value={value?.buttonText?.tr || ""}
        onChange={(e) =>
          onChange({
            ...(value || {}),
            buttonText: { tr: e.target.value, en: value?.buttonText?.en },
          } as any)
        }
      />

      <TextField
        label="Banner button link"
        value={value?.buttonLink || ""}
        onChange={(e) =>
          onChange({
            ...(value || {}),
            buttonLink: e.target.value,
          } as any)
        }
      />
    </div>
  );
}
